import { DropdownListItem, FlexBox } from "@brg/ui";
import { LayoutConst } from "core";
import { DesignerLink } from "shared/pages/explore/styles";
import styled, { css } from "styled-components";

export const Container = styled(FlexBox)`
    display: flex;
    flex-flow: row;
    place-items: center;
    width: 100%;
    justify-content: space-between;
`;

export const DropdownWrapper = styled.div`
    max-width: 180px;
    z-index: 9999;

    ${DropdownListItem} {
        display: flex;
        flex-flow: row;
        justify-content: space-between;
    }
`;

export const ListItem = styled(DropdownListItem)`
    font-family: Inter;
    font-size: 15px;
    font-style: normal;
    font-weight: 600;
    line-height: 20px; /* 133.333% */
    letter-spacing: -0.3px;
    padding: 12px 16px;

    ${({ disable }) => disable && css`
        color: #151514;
    `};

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        font-size: 13px;
        line-height: 16px; /* 133.333% */
    }
`;

export const OtherMediaWrapper = styled(FlexBox)<{ isOpen?: boolean }>`
    flex-flow: row;
    cursor: pointer;
    div {
        font-size: 17px;
        line-height: 22px;
        letter-spacing: -0.02em;
        display: inline-block;
        white-space: pre;
        color: #909090;
        font-family: Inter;
        font-style: normal;
        font-weight: bold;
    }

    svg {
        width: 16px;
        height: 16px;
        margin-left: 5px;
        transition: transform 0.2s;
    }

    ${({ isOpen }) => isOpen && css`
        svg path {
            fill: #151514;
        }
        svg {
            transform: rotate(180deg);
            transition: transform 0.2s;
        }
    `};

    &:hover {
        div {
            color: #151514;
        }

        svg path {
            fill: #151514;
        }
    }
`;

export const LeftSideContaner = styled(FlexBox)`

`;

export const RightSideContaner = styled(LeftSideContaner)`
    margin-left: 24px;
`

export const Link = styled(DesignerLink)`
    font-family: 'Inter';
    font-size: 17px;
    font-style: normal;
    font-weight: bold;
    line-height: 22px;
    letter-spacing: -0.02em;
`;

export const SwitcherItem = styled(FlexBox)<{ isActive: boolean }>`
    color: ${({ isActive }) => isActive ? '#151514' : '#909090'};
    font-family: Inter;
    font-size: 17px;
    font-style: normal;
    font-weight: 600;
    line-height: 22px; /* 129.412% */
    letter-spacing: -0.34px;
    transition: color 0.2s;
    cursor: pointer;

    &:hover {
        color: #151514;
        transition: color 0.2s;
    }


`;

export const SvgWrapper = styled.div`
    width: 16px;
`;

export const ArchiveLabel = styled(FlexBox)`
    padding: 5px 16px;
    border: 1px solid #909090;
    border-radius: 5px;
    color: #151514;
    font-family: Inter;
    font-size: 15px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px; /* 133.333% */
    letter-spacing: -0.3px;
    white-space: nowrap;
    text-transform: lowercase;
`;

export const DropdownContainer = styled(FlexBox)`
    flex-flow: column;
    position: absolute;
    top: 25px;
    left: 0px;
    width: 360px;
    box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.12);
    border-radius: 3px;
    z-index: 9999;
`


export const TabContainer = styled(FlexBox)`
    flex-flow: row;
    border-bottom: 1px solid #cdcdcd;
    background-color: #f2f2f2;

    div {
        padding: 6px 16px;
        font-family: Inter;
        font-size: 15px;
        font-style: normal;
        font-weight: 600;
        line-height: 20px; /* 133.333% */
        letter-spacing: -0.3px;
    }
    
`;

export const TabItem = styled.div<{ isActive?: boolean, hidden?: boolean }>`
    padding: 6px 16px;
    font-family: Inter;
    font-size: 15px;
    font-style: normal;
    font-weight: 600;
    line-height: 20px; /* 133.333% */
    letter-spacing: -0.3px;
    color: #909090;
    cursor: pointer;

    &:hover {
        color: #151514;
        transition: color 0.2s;
    }

    ${({ isActive }) => isActive && css`
        color: #151514;
    `};
    
    ${({ hidden }) => hidden && css`
        display: none;
    `};
`;import { DropdownListItem, FlexBox } from "@brg/ui";
import { LayoutConst } from "core";
import { DesignerLink } from "shared/pages/explore/styles";
import styled, { css } from "styled-components";

export const Container = styled(FlexBox)`
    display: flex;
    flex-flow: row;
    place-items: center;
    width: 100%;
    justify-content: space-between;
`;

export const DropdownWrapper = styled.div`
    max-width: 180px;
    z-index: 9999;

    ${DropdownListItem} {
        display: flex;
        flex-flow: row;
        justify-content: space-between;
    }
`;

export const ListItem = styled(DropdownListItem)`
    font-family: Inter;
    font-size: 15px;
    font-style: normal;
    font-weight: 600;
    line-height: 20px; /* 133.333% */
    letter-spacing: -0.3px;
    padding: 12px 16px;

    ${({ disable }) => disable && css`
        color: #151514;
    `};

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        font-size: 13px;
        line-height: 16px; /* 133.333% */
    }
`;

export const OtherMediaWrapper = styled(FlexBox)<{ isOpen?: boolean }>`
    flex-flow: row;
    cursor: pointer;
    div {
        font-size: 17px;
        line-height: 22px;
        letter-spacing: -0.02em;
        display: inline-block;
        white-space: pre;
        color: #909090;
        font-family: Inter;
        font-style: normal;
        font-weight: bold;
    }

    svg {
        width: 16px;
        height: 16px;
        margin-left: 5px;
        transition: transform 0.2s;
    }

    ${({ isOpen }) => isOpen && css`
        svg path {
            fill: #151514;
        }
        svg {
            transform: rotate(180deg);
            transition: transform 0.2s;
        }
    `};

    &:hover {
        div {
            color: #151514;
        }

        svg path {
            fill: #151514;
        }
    }
`;

export const LeftSideContaner = styled(FlexBox)`

`;

export const RightSideContaner = styled(LeftSideContaner)`
    margin-left: 24px;
`

export const Link = styled(DesignerLink)`
    font-family: 'Inter';
    font-size: 17px;
    font-style: normal;
    font-weight: bold;
    line-height: 22px;
    letter-spacing: -0.02em;
`;

export const SwitcherItem = styled(FlexBox)<{ isActive: boolean }>`
    color: ${({ isActive }) => isActive ? '#151514' : '#909090'};
    font-family: Inter;
    font-size: 17px;
    font-style: normal;
    font-weight: 600;
    line-height: 22px; /* 129.412% */
    letter-spacing: -0.34px;
    transition: color 0.2s;
    cursor: pointer;

    &:hover {
        color: #151514;
        transition: color 0.2s;
    }


`;

export const SvgWrapper = styled.div`
    width: 16px;
`;

export const ArchiveLabel = styled(FlexBox)`
    padding: 5px 16px;
    border: 1px solid #909090;
    border-radius: 5px;
    color: #151514;
    font-family: Inter;
    font-size: 15px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px; /* 133.333% */
    letter-spacing: -0.3px;
    white-space: nowrap;
    text-transform: lowercase;
`;

export const DropdownContainer = styled(FlexBox)`
    flex-flow: column;
    position: absolute;
    top: 25px;
    left: 0px;
    width: 360px;
    box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.12);
    border-radius: 3px;
    z-index: 9999;
`


export const TabContainer = styled(FlexBox)`
    flex-flow: row;
    border-bottom: 1px solid #cdcdcd;
    background-color: #f2f2f2;

    div {
        padding: 6px 16px;
        font-family: Inter;
        font-size: 15px;
        font-style: normal;
        font-weight: 600;
        line-height: 20px; /* 133.333% */
        letter-spacing: -0.3px;
    }
    
`;

export const TabItem = styled.div<{ isActive?: boolean, hidden?: boolean }>`
    padding: 6px 16px;
    font-family: Inter;
    font-size: 15px;
    font-style: normal;
    font-weight: 600;
    line-height: 20px; /* 133.333% */
    letter-spacing: -0.3px;
    color: #909090;
    cursor: pointer;

    &:hover {
        color: #151514;
        transition: color 0.2s;
    }

    ${({ isActive }) => isActive && css`
        color: #151514;
    `};
    
    ${({ hidden }) => hidden && css`
        display: none;
    `};
`;